import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { MenuCreateDishSelectPage } from '../../../menu/menu-create/menu-create-dish-select/menu-create-dish-select';
import { CartasMenusListPage } from '../../cartas-menus-list/cartas-menus-list';
import { MenuCreateTitlePage } from '../../../menu/menu-create/menu-create-title/menu-create-title';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { MenuCreatePricenextrasPage } from '../../../menu/menu-create/menu-create-pricenextras/menu-create-pricenextras';
import moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { SelectDateTkPickupDay } from '../../../components/popups/select-date-tk-pickup-day/select-date-tk-pickup-day';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { MenuCreateSelectTemplatePage } from '../../../menu/menu-create/menu-create-select-template/menu-create-select-template';
import { AnayliticsMenuComboPage } from '../../../components/anaylitics-menu-combo/anaylitics-menu-combo';

/**
 * Generated class for the ComponentMenuViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'component-menu-view',
    templateUrl: 'component-menu-view.html',
})
export class ComponentMenuViewPage implements OnInit {

    @Input() state: string = "view";
    @ViewChild('enlacesMenuContainer') enlacesMenuContainer: ElementRef;
    colors: any;
    total_views = 0;
    total_shares = 0;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private menuServices: MenuServices,
        public globals: Globals,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public http: HttpClient,
        public modalCtrl: ModalController) {
    }

    ngOnInit() {
        this.getViewsShares();
        //al hacer cualquier click cambiar el estado de "new" a "view"
        const container = this.enlacesMenuContainer.nativeElement;
        container.addEventListener('click', (event) => {
            this.state = "view";
        });
        //load colors
        this.colors = this.globals.getColorsElements();
    }

    ngOnDestroy() {
        //al destruir componente cambiar el estado de "new" a "view"
        if (this.state === 'new') {
            this.state = "view";
        }
    }

    createSection() {
        this.navCtrl.push(MenuCreateDishSelectPage, {
            type: this.menuServices.menu_tmp.style,
            section: Object.keys(this.menuServices.menu_tmp.sections).length,
            section_complete: this.menuServices.menu_tmp.sections,
            update: true,
            menu_uid: this.menuServices.menu_tmp.UID,
            menu: this.menuServices.menu_tmp,
            new: true,
            menu_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
            show_prices: false
        });
    }

    editName() {
        this.menuServices.edit = true;
        this.menuServices.edit_type = 'header';
        //
        this.navCtrl.push(MenuCreateTitlePage, {
            type: this.menuServices.menu_tmp.style,
            update: true,
            menu_uid: this.menuServices.menu_tmp.UID,
            menu_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
            reference: this.menuServices.menu_tmp.reference,
            title_es: this.menuServices.menu_tmp.title_es,
            title_ca: this.menuServices.menu_tmp.title_ca,
            title_en: this.menuServices.menu_tmp.title_en,
            title_de: this.menuServices.menu_tmp.title_de,
            title_it: this.menuServices.menu_tmp.title_it,
            title_fr: this.menuServices.menu_tmp.title_fr,
            subtitle: this.menuServices.menu_tmp.subtitle_es,
        });
    }

    editSection(index) {
        this.navCtrl.push(MenuCreateDishSelectPage, {
            type: this.menuServices.menu_tmp.style,
            section: index,
            section_complete: this.menuServices.menu_tmp.sections,
            update: true,
            menu_uid: this.menuServices.menu_tmp.UID,
            menu: this.menuServices.menu_tmp,
            new: false,
            menu_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
            show_prices: false
        });
    }

    editPrice() {
        this.navCtrl.push(MenuCreatePricenextrasPage, {
            update: true,
            menu_uid: this.menuServices.menu_tmp.UID,
            price: this.menuServices.menu_tmp.price,
            price_takeaway: this.menuServices.menu_tmp.price_takeaway,
            pan_vino_agua_si: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_si,
            pan_vino_agua_no: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_no,
            refresco_si: this.menuServices.menu_tmp.extras_footer.refresco_si,
            refresco_no: this.menuServices.menu_tmp.extras_footer.refresco_no,
            cafe_si: this.menuServices.menu_tmp.extras_footer.cafe_si,
            cafe_no: this.menuServices.menu_tmp.extras_footer.cafe_no,
            extra_price: this.menuServices.menu_tmp.extra,
            footer: this.menuServices.menu_tmp.footer,
            type: this.menuServices.menu_tmp.style,
            menu_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
        });
    }

    deleteSection(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //delete
                        delete this.menuServices.menu_tmp.sections[index];
                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.menuServices.menu_tmp.sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        //update
                        this.menuServices.menu_tmp.sections = obj_help;

                        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
                            'sections': this.menuServices.menu_tmp.sections,
                        });
                        this.menuServices.edit = false;
                    }
                }
            ]
        });
        alert.present();
    }

    deleteMenu() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-menu'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //this.globals.GAtrackView('Menu', 'Menu - Delete', this.globals.restaurant.email, 'Delete', 'Delete menu', 'Menu', this.menu_uid);
                        this.menuServices.valueChanges.unsubscribe();
                        if (this.menuServices.filteredMenusActive) {
                            this.menuServices.filteredMenus.splice(this.menuServices.filteredMenus.findIndex(item => item.UID == this.menuServices.menu_tmp.UID), 1);
                            this.menuServices.filteredMenus = [...this.menuServices.filteredMenus];
                        }
                        this.menuServices.menus_array.splice(this.menuServices.menus_array.findIndex(item => item.UID == this.menuServices.menu_tmp.UID), 1);
                        this.menuServices.menus_array = [...this.menuServices.menus_array];
                        this.menuServices.delete(this.menuServices.menu_tmp.UID);
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }

    async redirect() {
        await this.globals.delay(1000);
        this.navCtrl.setRoot(CartasMenusListPage);
    }

    reorderSections(indexes) {
        let element = this.menuServices.sections_array_tmp[indexes.from];
        this.menuServices.sections_array_tmp.splice(indexes.from, 1);
        this.menuServices.sections_array_tmp.splice(indexes.to, 0, element);
    }

    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.menuServices.sections_array_tmp.length > i; i++) {
            _obj[i] = {
                name: this.menuServices.sections_array_tmp[i].name || '',
                name_ca: this.menuServices.sections_array_tmp[i].name_ca || '',
                name_de: this.menuServices.sections_array_tmp[i].name_de || '',
                name_en: this.menuServices.sections_array_tmp[i].name_en || '',
                name_fr: this.menuServices.sections_array_tmp[i].name_fr || '',
                name_it: this.menuServices.sections_array_tmp[i].name_it || '',
                order: i,
                dish: this.menuServices.sections_array_tmp[i].dish,
            };
        }
        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            'sections': _obj,
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    updateOptions() {
        if (this.menuServices.menu_tmp.tpv_active == undefined) {
            this.menuServices.menu_tmp.tpv_active = true;
        }
        if (this.menuServices.menu_tmp.pos_favourite == undefined) {
            this.menuServices.menu_tmp.pos_favourite = false;
        }
        if (this.menuServices.menu_tmp.digital_app == undefined) {
            this.menuServices.menu_tmp.digital_app = false;
        }
        if (this.menuServices.menu_tmp.tk_active == undefined) {
            this.menuServices.menu_tmp.tk_active = false;
        }
        if (this.menuServices.menu_tmp.order_share == undefined) {
            this.menuServices.menu_tmp.order_share = 0;
        }

        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            logo_show: this.menuServices.menu_tmp.logo_show,
            enumerate: this.menuServices.menu_tmp.enumerate,
            footer_show: this.menuServices.menu_tmp.footer_show,
            tpv_active: this.menuServices.menu_tmp.tpv_active,
            pos_favourite: this.menuServices.menu_tmp.pos_favourite,
            digital_app: this.menuServices.menu_tmp.digital_app,
            tk_active: this.menuServices.menu_tmp.tk_active,
            order_share: this.menuServices.menu_tmp.order_share
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    setColor(color) {
        this.menuServices.afs.collection('menus').doc(this.menuServices.menu_tmp.UID).update({
            pos_background_color: color.pos_background_color,
            pos_border_color: color.pos_border_color,
            pos_color_name: color.name
        });
        document.getElementById('collapseMenuColor').classList.remove('show');
        document.getElementById('menuColor').classList.add('collapsed');
    }
    setBackgroundColor(menu) {
        return {
            'background-color': menu.pos_background_color,
            'border': '1px solid ' + menu.pos_border_color,
            'margin-left': '9px',
        }
    }

    license() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    async getViewsShares() {
        const params = new HttpParams()
            .set('rest_uid', this.globals.restaurant_uid)
            .set('first_date', moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .set('last_date', moment().format('YYYY-MM-DD HH:mm:ss'))
            .set('element_uid', this.menuServices.menu_tmp.UID);

        this.http.post(this.globals.analytics_path + 'analytics/total_views_share_element', params, {})
            .subscribe(async response => {
                this.total_views = response['total_views'];
                this.total_shares = response['total_share'];
            });
    }

    changeTkPickupDay() {
        let modal = this.modalCtrl.create(SelectDateTkPickupDay, {
            tk_pickup_day: this.menuServices.menu_tmp.tk_pickup_day,
            element: this.menuServices.menu_tmp,
            type: 'menu'
        });
        modal.present();
    }

    goToConfigLogo() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.push(ConfigurationImagesPage);
    }

    selectTemplate() {
        this.navCtrl.push(MenuCreateSelectTemplatePage, {
            update_state: true,
            menu_uid: this.menuServices.menu_tmp.UID,
            template_name: this.menuServices.menu_tmp.template_name,
            menu_name: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp),
        });
    }

    openAnalytica() {
        this.navCtrl.push(AnayliticsMenuComboPage, {
            menu_uid: this.menuServices.menu_tmp.UID,
            menu_title: this.globals.returnLangCartaMenuCombo(this.menuServices.menu_tmp)
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/cartas-menus/carta-menu-view/component-menu-view/component-menu-view.ts